/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  title: string;
  description: React.ReactNode;
  desktopImage: React.ReactNode;
  mobileImage: React.ReactNode;
};

const styles = {
  mobileCertificate: (theme: Theme) => css`
    display: none;
    margin-bottom: calc(${theme.spacing(32)} * -1);
    ${theme.breakpoints.down('sm')} {
      display: flex;
      justify-content: center;
    }
  `,
  imageContainerMobile: css`
    height: 165px;
    width: 259px;
  `,
  moduleContent: (theme: Theme) => css`
    border: 2px solid ${theme.palette.gray[300]};
    border-radius: 8px;
  `,
  leftColumnContent: (theme: Theme) => css`
    padding: ${theme.spacing(32)};
    ${theme.breakpoints.down('sm')} {
      padding: ${theme.spacing(48, 32, 32, 32)};
    }
    ${theme.breakpoints.down('xs')} {
      padding: ${theme.spacing(48, 16, 16, 16)};
    }
  `,
  title: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(16)};
    ${theme.breakpoints.down('sm')} {
      margin-bottom: ${theme.spacing(8)};
    }
  `,
  certImageContainerDesktop: (theme: Theme) => css`
    min-height: 168px;
    position: relative;
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  `,
  backgroundBlobContainer: css`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 96%;
    overflow: hidden;
  `,
  backgroundBlob: (theme: Theme) => css`
    position: absolute;
    height: 200%;
    width: 200%;
    background-color: ${theme.palette.blue[100]};
    opacity: 0.5;
    clip-path: ellipse(30% 100% at 30% 10%);
  `,
};

const CertificateAndBenefitsText = ({ title, description, desktopImage, mobileImage }: Props) => {
  return (
    <Grid item xs={12}>
      <div css={styles.mobileCertificate}>
        <div css={styles.imageContainerMobile}>{mobileImage}</div>
      </div>
      <div css={styles.moduleContent}>
        <Grid container>
          <Grid item xs={12} md={7}>
            <div css={styles.leftColumnContent}>
              <Typography variant="h1semibold" component="h2" css={styles.title}>
                {title}
              </Typography>
              {description}
            </div>
          </Grid>
          <Grid item xs={12} md={5} css={styles.certImageContainerDesktop}>
            <div css={styles.backgroundBlobContainer}>
              <div css={styles.backgroundBlob} />
            </div>
            {desktopImage}
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};

export default CertificateAndBenefitsText;
